import React from "react";
import { PhoneOutgoing } from "lucide-react";
import { convertTimeToLocation, getBrowserTimeZone } from "../../common/constant/constant";
import { formatTime } from "./constants";

const MissedCallNotice = ({ msgContent }) => {
  return (
    <div>
    <div className="flex items-center space-x-2 text-[#1B2A3D] font-medium text-sm">
      <PhoneOutgoing className="w-4 h-4 text-red-500" />
      <span>Call attempt was missed.</span>
    </div>
    <div className="text-xs text-right text-[#667783] py-3 block">{formatTime(convertTimeToLocation(msgContent.CallDateTime))}</div> 
    </div>
  );
};

export default MissedCallNotice;
